import { createStructuredSelector } from 'reselect';
import {
  ENT_SUPPLIER_LIST, ENT_SUPPLIER_LIST_SUCCESS, ENT_SUPPLIER_LIST_ERROR,
  ENT_SUPPLIER_PAGE_SET,
  ENT_SUPPLIER_SEARCH_CHANGE,
  ENT_SUPPLIER_DETAIL, ENT_SUPPLIER_DETAIL_SUCCESS, ENT_SUPPLIER_DETAIL_ERROR,
  ENT_SUPPLIER_VIEW_MODAL_SET,
} from '../../actions';

export const NAME = 'ent_supplier';

export const EnterpriseSupplierList = (page, num_page, orderBy, filters) => ({ type: ENT_SUPPLIER_LIST, payload: { page, num_page, orderBy, filters } });
export const EnterpriseSupplierListSuccess = (data) => ({ type: ENT_SUPPLIER_LIST_SUCCESS, payload: data });
export const EnterpriseSupplierListError = (error) => ({ type: ENT_SUPPLIER_LIST_ERROR, payload: error });
export const EnterpriseSupplierPageSet = (data) => ({ type: ENT_SUPPLIER_PAGE_SET, payload: data });
export const EnterpriseSupplierSearchChange = (data) => ({ type: ENT_SUPPLIER_SEARCH_CHANGE, payload: data });
export const EnterpriseSupplierDetail = (data) => ({ type: ENT_SUPPLIER_DETAIL, payload: data });
export const EnterpriseSupplierDetailSuccess = (data) => ({ type: ENT_SUPPLIER_DETAIL_SUCCESS, payload: data });
export const EnterpriseSupplierDetailError = (error) => ({ type: ENT_SUPPLIER_DETAIL_ERROR, payload: error });
export const EnterpriseSupplierViewModalSet = (value) => ({ type: ENT_SUPPLIER_VIEW_MODAL_SET, payload: value });

const ent_supplier = (state) => state[NAME];
export const EnterpriseSupplierSelector = createStructuredSelector({ ent_supplier });
